import { VersionGame } from '../ninthAge/VersionGame';
import { Locale } from './Locale';
import { IEntity } from '../IEntity';

export interface UserPreference extends IEntity<string> {
  email: string;
  name: string;
  game: VersionGame;
  builderInterface: VersionInterface;
  useLatestVersion: boolean;
  isGuest: boolean;
  defaultLocale: Locale;
  location: google.maps.LatLngLiteral | null;
}

export enum VersionInterface {
  Classic = 0,
  OldSkool = 1,
}
